import { render } from "./BigInfoComponent.vue?vue&type=template&id=ca0186d8&scoped=true"
import script from "./BigInfoComponent.vue?vue&type=script&lang=js"
export * from "./BigInfoComponent.vue?vue&type=script&lang=js"

import "./BigInfoComponent.vue?vue&type=style&index=0&id=ca0186d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0186d8"]])

export default __exports__